module.exports = __webpack_public_path__ + "static/Rahnema2-18294018e5228528d50756032284bd3b.jpg";